import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const query = gql`
  mutation GenerateBraintreeToken {
    tokenGenerator: generateBraintreeClientToken {
      token
    }
  }
`;

export function useBraintreeToken() {
  const [fetchToken, { data, error, loading }] = useMutation(query);

  useEffect(() => {
    fetchToken();
  }, [fetchToken]);

  return { token: data?.tokenGenerator?.token, loading, error };
}
